// Canonical list of Mexican cities supported across Findperty.
// Used by: property filters, registration forms, property creation (agent/owner),
// agent territory selection, MVIP/Terreno municipality inputs, Master Partner profiles.
//
// Keep this list sorted alphabetically (Spanish locale). When adding new cities,
// import this file — do NOT duplicate lists elsewhere.

export const MEXICAN_CITIES = [
  // National principal cities
  "Aguascalientes",
  "Cancún",
  "Chihuahua",
  "Ciudad de México",
  "Cuernavaca",
  "Culiacán",
  "Guadalajara",
  "Hermosillo",
  "Juárez",
  "Los Cabos",
  "Mérida",
  "Metepec",
  "Mexicali",
  "Monterrey",
  "Morelia",
  "Oaxaca",
  "Playa del Carmen",
  "Puebla",
  "Puerto Vallarta",
  "Querétaro",
  "Saltillo",
  "San Luis Potosí",
  "San Pedro Garza García",
  "Tepoztlán",
  "Tijuana",
  "Torreón",
  "Tulum",
  "Valle de Bravo",
  "Zapopan",

  // Guanajuato principal cities (added Feb 2026)
  "Acámbaro",
  "Celaya",
  "Cortazar",
  "Dolores Hidalgo",
  "Guanajuato",
  "Irapuato",
  "León",
  "Moroleón",
  "Pénjamo",
  "Purísima del Rincón",
  "Salamanca",
  "Salvatierra",
  "San Francisco del Rincón",
  "San Luis de la Paz",
  "San Miguel de Allende",
  "Santa Cruz de Juventino Rosas",
  "Silao de la Victoria",
  "Uriangato",
  "Valle de Santiago",
].sort((a, b) => a.localeCompare(b, "es"));

export default MEXICAN_CITIES;
